import { useStoreApi } from 'reactflow'
export function useReactFlowStore() {
  const store = useStoreApi()
  const reactFlowStoreState = store.getState()
  return reactFlowStoreState
}
